<div data-testid="billing-this-month" class="billing">
  <div class="billing__header">
    <div class="billing__titles">
      <h4 data-testid="billing-title" class="billing__title">{{ title }}</h4>
      <p data-testid="billing-description" class="billing__description">
        @if (billing) {
          <span data-testid="billing-total" class="billing__total" [title]="usdFull(billing.total)">{{ usdCompact(billing.total) }}</span>
          across <button type="button" data-testid="billing-count" class="billing__count" [disabled]="!billing.count"
                         title="List this month's transactions" (click)="openTransactions()">{{ billing.count | adbCount:'transaction' }}</button>
          since {{ monthStart }}@if (comparisonText) {<span data-testid="billing-change" class="billing__change"> · {{ comparisonText }}</span>}.
        } @else {
          Successful payments since {{ monthStart }}.
        }
      </p>
    </div>
  </div>
  @if (failed) {
    <app-admin-dashboard-empty data-testid="billing-failed" icon="fa-regular fa-circle-exclamation" [title]="failedTitle"
                               body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  } @else if (billing) {
    @if (billing.top.length) {
      <ol data-testid="billing-bars" class="billing__bars" aria-label="Top companies by amount this month">
        @for (company of billing.top; track $index) {
          <li data-testid="billing-row" class="billing__row" [title]="company.companyName + ' · ' + usdFull(company.amount)">
            <span data-testid="billing-company" class="billing__company">{{ company.companyName }}</span>
            <span class="billing__track"><span data-testid="billing-bar" class="billing__bar" [style.width.%]="barWidth(company.amount)"></span></span>
            <span data-testid="billing-amount" class="billing__amount">{{ usdCompact(company.amount) }}</span>
          </li>
        }
      </ol>
    } @else {
      <app-admin-dashboard-empty data-testid="empty" icon="fa-regular fa-receipt" title="No payments this month"></app-admin-dashboard-empty>
    }
  }
</div>
